import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class FormValidators {
  static integer = (control: AbstractControl): ValidationErrors | null => {
    let errors = null;

    if (control.value && control.value % 1 !== 0) {
      errors = { integer: { value: control.value } };
    }

    return errors;
  };
}

const MODEL_FORMAT_REGEX = /^[A-Za-z0-9]+$/;

/** Models must contain only letters and digits, e.g. `A12`, `pro4`. */
export function modelFormatValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    return MODEL_FORMAT_REGEX.test(value) ? null : { modelFormat: true };
  };
}

export function noOnlyWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }
    const isWhitespace = value.trim().length === 0;
    return isWhitespace ? { whitespace: true } : null;
  };
}
